<template>
  <div class="chart-container" v-loading="loading">
    <a-row :gutter="12" class="main-container">
      <div style="width: 100px">
        <el-slider
          v-model="weekSp"
          range
          vertical
          :min="min"
          :max="max"
          :format-tooltip="formatTooltip"
          class="custom-slider"
          :tooltip-class="'slider-tooltip'"
          :marks="getMarks()"
          :show-stops="true"
          height="550px"
          @change="GetChartData"
        />
      </div>
      <div style="width: calc(100% - 100px)">
        <!-- 上面的日期div - 靠右对齐 -->
        <a-row :gutter="[0, 16]" class="date-row">
          <div class="date-range-container">
            <div class="date-range">
              <span class="date-label">{{
                formatDateNumber(weekList[weekSp[0]])
              }}</span>
              <span class="date-separator">至</span>
              <span class="date-label">{{
                formatDateNumber(weekList[weekSp[1]])
              }}</span>
            </div>
          </div>
        </a-row>

        <!-- 下面的图表div - 靠左对齐 -->
        <a-row justify="start">
          <div class="chart-container">
            <div class="my-charts" ref="myChart"></div>
          </div>
        </a-row>
      </div>
    </a-row>
  </div>
</template>

<script>
import { getAllWeekList, getChartWeekTop } from "@/api/charts.js";
export default {
  data() {
    return {
      weekSp: [30, 60],
      min: 0,
      max: 1000,
      weekList: [],
      weekInfo: [],

      chart: null,
      wciyAxis: {},
      tkyAxis: {},
      adScore: [],
      extlinkScore: [],
      liveScore: [],
      mpdocScore: [],
      queryScore: [],
      scoreExp: [],
      w1wScore: [],
      finderScore: [],
      tk_searchScore: [],
      tk_topScore: [],
      loading: null,
      wciChartData: [],
      tkChartData: [],
    };
  },
  created() {
    this.InitSlider();
  },
  computed: {},
  methods: {
    InitSlider() {
      getAllWeekList().then((res) => {
        if (res.code == 0) {
          this.weekList = res.data.map((item) => item.ymd);
          this.weekInfo = res.data;
          this.max = res.data.length - 1;
          this.weekSp = [res.data.length - 52, res.data.length - 1];
          this.GetChartData();
        }
      });
    },
    GetChartData() {
      this.loading = true;
      getChartWeekTop(
        this.weekList[this.weekSp[0]],
        this.weekList[this.weekSp[1]]
      ).then((res) => {
        if (res.code == 0) {
          this.wciChartData = res.data.wciinfo;
          this.tkChartData = res.data.tkinfo;
          this.wciyAxis = this.wciChartData.map((item) => item.keyword);
          this.adScore = this.wciChartData.map((item) => item.adScore);
          this.extlinkScore = this.wciChartData.map(
            (item) => item.extlinkScore
          );
          this.liveScore = this.wciChartData.map((item) => item.liveScore);
          this.mpdocScore = this.wciChartData.map((item) => item.mpdocScore);
          this.queryScore = this.wciChartData.map((item) => item.queryScore);
          this.scoreExp = this.wciChartData.map((item) => item.scoreExp);
          this.w1wScore = this.wciChartData.map((item) => item.w1wScore);
          this.finderScore = this.wciChartData.map((item) => item.finderScore);

          this.tkyAxis = this.tkChartData.map((item) => item.keyword);
          this.tk_searchScore = this.tkChartData.map(
            (item) => item.searchScore
          );
          this.tk_topScore = this.tkChartData.map((item) => item.topScore);
          this.InitOptions();
        } else {
          this.$message.error(res.msg);
        }
        this.loading = false;
      });
    },

    formatTooltip(val) {
      return this.formatDateNumber(this.weekList[val]);
    },
    getMarks() {
      // 添加一些关键时间点的标记，使滑块更直观
      const marks = {};
      const step = Math.floor(this.max / 4); // 显示6个标记点

      for (let i = 0; i <= 4; i++) {
        const index = Math.floor(i * step);
        if (index <= this.max && this.weekList[index]) {
          marks[index] = { label: this.weekList[index] }; // 只显示月日
        }
      }
      return marks;
    },
    formatDateNumber(dateNumber) {
      const dateStr = String(dateNumber);
      if (!/^\d{8}$/.test(dateStr)) {
        return dateNumber; // 如果格式不正确，返回原始值
      }
      const year = dateStr.substring(0, 4);
      const month = dateStr.substring(4, 6);
      const day = dateStr.substring(6, 8);

      var indexNum = this.weekList.findIndex((item) => item === dateNumber);
      var weekinfo = this.weekInfo[indexNum];

      return `${year}年${month}月${day}日[${weekinfo.year}年,第${weekinfo.yearIndex}周]`;
    },
    handleResize() {
      if (this.chart) {
        this.chart.resize();
      }
    },
    InitOptions() {
      this.chart = this.$echarts.init(this.$refs.myChart);
      // 添加点击事件监听器
      this.chart.setOption({
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
          position: function (pos, params, el, elRect, size) {
            const obj = {
              top: 10,
            };
            obj[["left", "right"][+(pos[0] < size.viewSize[0] / 2)]] = 30;
            return obj;
          },
          formatter: (params) => {
            if (!params || params.length === 0) return "";

            // 使用div包裹所有内容，添加基本样式
            let result = `<div style="padding: 8px;">`;

            // 添加标题，使用粗体和更大的字号
            result += `<div style="font-weight: bold; font-size: 14px; margin-bottom: 8px;">${params[0].name}</div>`;

            // 过滤并处理上图数据
            const leftParams = params.filter((item) => item.axisIndex === 0);
            if (leftParams.length > 0) {
              // 计算总计值，添加安全检查
              const total = leftParams.reduce(
                (sum, item) => sum + (parseFloat(item.value) || 0),
                0
              );

              // 添加每个数据项，使用flex布局对齐
              leftParams.forEach((item) => {
                const value = parseFloat(item.value) || 0;
                result += `<div style="display: flex; justify-content: space-between; margin: 2px 0; min-width: 180px;">
        <span style="display: flex; align-items: center;">${item.marker}${
                  item.seriesName
                }</span>
        <span style="font-weight: 500;">${value.toLocaleString()}</span>
      </div>`;
              });

              // 添加分隔线和总计，使用不同的样式突出显示
              result += `<div style="margin: 6px 0; border-top: 1px solid #ddd;"></div>
    <div style="display: flex; justify-content: space-between; font-weight: bold; color: #1890ff;">
      总计
      <span>${total.toLocaleString()}</span>
    </div>`;
            }

            // 过滤并处理下图数据，如果存在则添加分隔线和数据
            const rightParams = params.filter((item) => item.axisIndex === 1);
            if (rightParams.length > 0) {
              // 计算总计值，添加安全检查
              const total = rightParams.reduce(
                (sum, item) => sum + (parseFloat(item.value) || 0),
                0
              );

              // 添加每个数据项，使用flex布局对齐
              rightParams.forEach((item) => {
                const value = parseFloat(item.value) || 0;
                result += `<div style="display: flex; justify-content: space-between; margin: 2px 0; min-width: 180px;">
        <span style="display: flex; align-items: center;">${item.marker}${
                  item.seriesName
                }</span>
        <span style="font-weight: 500;">${value.toLocaleString()}</span>
      </div>`;
              });

              // 添加分隔线和总计，使用不同的样式突出显示
              result += `<div style="margin: 6px 0; border-top: 1px solid #ddd;"></div>
    <div style="display: flex; justify-content: space-between; font-weight: bold; color: #1890ff;">
      总计
      <span>${total.toLocaleString()}</span>
    </div>`;
            }

            // 关闭外层div
            result += `</div>`;
            return result;
          },
        },
        legend: {},
        grid: [
          {
            left: "5%",
            right: "60%",
            bottom: "10%",
          },
          {
            left: "55%",
            right: "5%",
            bottom: "10%",
          },
        ],
        xAxis: [
          {
            type: "value",
            gridIndex: 0,
            min: 0,
            axisLabel: {
              formatter: function (value) {
                // 超过1亿用b
                if (value >= 100000000) {
                  return value / 100000000 + " B";
                }
                // 超过1百万用m
                else if (value >= 1000000) {
                  return value / 1000000 + " M";
                }
                // 超过1千用k
                else if (value >= 1000) {
                  return value / 1000 + " K";
                }
                // 小于1千直接返回原值
                return value;
              },
            },
          },
          {
            type: "value",
            gridIndex: 1,
            min: 0,
            axisLabel: {
              formatter: function (value) {
                // 超过1亿用b
                if (value >= 100000000) {
                  return value / 100000000 + " B";
                }
                // 超过1百万用m
                else if (value >= 1000000) {
                  return value / 1000000 + " M";
                }
                // 超过1千用k
                else if (value >= 1000) {
                  return value / 1000 + " K";
                }
                // 小于1千直接返回原值
                return value;
              },
            },
          },
        ],
        yAxis: [
          {
            type: "category",
            data: this.wciyAxis,
            axisPointer: {
              show: true,
            },
            triggerEvent: true,
            gridIndex: 0,
          },
          {
            type: "category",
            data: this.tkyAxis,
            axisPointer: {
              show: true,
            },
            triggerEvent: true,
            gridIndex: 1,
          },
        ],
        series: [
          {
            name: "WCI广告",
            type: "bar",
            stack: "total",
            label: {
              show: false,
            },
            emphasis: {
              focus: "series",
            },
            data: this.adScore,
          },
          {
            name: "WCI外链",
            type: "bar",
            stack: "total",
            label: {
              show: false,
            },
            emphasis: {
              focus: "series",
            },
            data: this.extlinkScore,
          },
          {
            name: "WCI直播",
            type: "bar",
            stack: "total",
            label: {
              show: false,
            },
            emphasis: {
              focus: "series",
            },
            data: this.liveScore,
          },
          {
            name: "WCI公众号",
            type: "bar",
            stack: "total",
            label: {
              show: false,
            },
            emphasis: {
              focus: "series",
            },
            data: this.mpdocScore,
          },
          {
            name: "WCI搜一搜",
            type: "bar",
            stack: "total",
            label: {
              show: false,
            },
            emphasis: {
              focus: "series",
            },
            data: this.queryScore,
          },
          {
            name: "WCI问一问",
            type: "bar",
            stack: "total",
            label: {
              show: false,
            },
            emphasis: {
              focus: "series",
            },
            data: this.w1wScore,
          },
          {
            name: "WCI视频号",
            type: "bar",
            stack: "total",
            label: {
              show: false,
            },
            emphasis: {
              focus: "series",
            },
            itemStyle: {
              color: "#ff0000",
            },
            data: this.finderScore,
          },
          {
            name: "TK搜索",
            type: "bar",
            stack: "total1",
            label: {
              show: false,
            },
            emphasis: {
              focus: "series",
            },
            itemStyle: {
              color: "rgb(1, 191, 236)",
            },
            data: this.tk_searchScore,
            xAxisIndex: 1,
            yAxisIndex: 1,
          },
          {
            name: "TK综合",
            type: "bar",
            stack: "total1",
            label: {
              show: false,
            },
            emphasis: {
              focus: "series",
            },
            itemStyle: {
              color: "rgb(77, 119, 255)",
            },
            data: this.tk_topScore,
            xAxisIndex: 1,
            yAxisIndex: 1,
          },
        ],
      });
    },
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
  },
};
</script>

<style lang="scss" scoped>
.main-container {
  width: 100%;
  display: flex;
  height: 650px;
  padding: 25px;
}

.content-row {
  width: 100%;
  height: 100%;
  flex-wrap: nowrap; // 防止换行
}

.date-range-container {
  display: inline-block;
  /* 或者直接设置 */
  text-align: right;
}

.chart-container {
  flex: 1; // 占据剩余空间
  min-width: 0; // 允许内容缩小以适应空间
  overflow: hidden; // 防止内容溢出
  padding: 5px; // 可选，为了防止内容被截断;
  height: calc(100% - 40px); // 减去文字内容的高度
}

.my-charts {
  width: 100%;
  height: 600px;
}

// 保留原有的日期样式
.date-range {
  display: flex;
  align-items: center;
  background-color: #f0f5ff;
  padding: 6px 12px;
  border-radius: 4px;
  border: 1px solid #e1f3ff;
  white-space: nowrap;
  min-width: 280px;
}

.date-row {
  width: 100%;
  display: flex;
  justify-content: flex-end;
}

.date-label {
  color: #1890ff;
  font-weight: 500;
}

.date-separator {
  color: #999;
  margin: 0 4px;
}
</style>